import { render, staticRenderFns } from "./PlayStateSticky.vue?vue&type=template&id=2f9bb9e8&scoped=true&"
import script from "./PlayStateSticky.vue?vue&type=script&lang=js&"
export * from "./PlayStateSticky.vue?vue&type=script&lang=js&"
import style0 from "./PlayStateSticky.vue?vue&type=style&index=0&id=2f9bb9e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9bb9e8",
  null
  
)

export default component.exports